import DBOperationsComb from "src/utils/dbOperationsComb";
import Constants from "src/utils/constants";
import Exception from "src/utils/exception";

async function insertSignature(data, offlineFirst = true) {
  try {
    return await DBOperationsComb.insertData(
      Constants.enums.TABLES_NAME_ENUM.SIGNATURES_TABLE,
      data,
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getSignatureById(id, offlineFirst = true) {
  try {
    return await DBOperationsComb.getData(
      Constants.enums.TABLES_NAME_ENUM.SIGNATURES_TABLE,
      id,
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function updateSignature(data, offlineFirst = true) {
  try {
    return await DBOperationsComb.updateData(
      Constants.enums.TABLES_NAME_ENUM.SIGNATURES_TABLE,
      data,
      offlineFirst
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  insertSignature,
  getSignatureById,
  updateSignature
};
